import { Reveal } from "@/components/okaia/Reveal";

const POINTS = [
  "Une approche centrée sur votre situation réelle",
  "Une orientation basée sur vos besoins et vos objectifs",
  "Une expérience de plus de 30 ans dans le commerce et la relation client",
  "Une volonté de privilégier des solutions utiles, cohérentes et adaptées",
];

export const Trust = () => (
  <section id="pourquoi" data-testid="section-pourquoi" className="bg-[#F0EBE1] py-16 md:py-24">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <Reveal>
            <p className="okaia-overline mb-6 text-[#B39265]">Chapitre 05 — Confiance</p>
            <h2 className="font-serif-display text-4xl leading-[1.1] tracking-tight text-[#0B2215] md:text-5xl">
              Pourquoi choisir OKAÏA&nbsp;Dév&nbsp;?
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 space-y-6 text-base font-light leading-relaxed text-[#4A5A52]">
              <p className="font-serif-display text-xl italic text-[#0B2215] md:text-2xl">
                Parce qu'avant de proposer une solution, il faut d'abord comprendre la
                situation.
              </p>
              <p>
                OKAÏA Dév s'appuie sur une approche simple&nbsp;: écouter, clarifier, orienter.
              </p>
              <p>
                L'objectif n'est pas de vous diriger vers une solution standardisée, mais de
                mieux comprendre votre projet, vos priorités et vos besoins afin de vous aider
                à avancer dans une direction cohérente.
              </p>
              <p>
                Cette approche repose sur l'expérience du terrain, la relation client et la
                recherche de solutions réellement adaptées à chaque situation.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.25}>
            <div className="mt-12 flex items-baseline gap-4">
              <span className="font-serif-display text-7xl font-medium italic text-[#C8A97E] md:text-8xl">30</span>
              <span className="max-w-[200px] text-sm font-light leading-snug text-[#4A5A52]">
                ans d'expérience dans le commerce et la relation client
              </span>
            </div>
          </Reveal>
        </div>

        <div className="flex flex-col justify-center lg:col-span-5 lg:col-start-8">
          {POINTS.map((p, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div data-testid={`trust-point-${i + 1}`} className="flex items-start gap-6 border-t border-[#0B2215]/15 py-8 last:border-b">
                <span className="font-serif-display text-lg italic text-[#C8A97E]">0{i + 1}</span>
                <p className="font-serif-display text-lg leading-snug text-[#0B2215] md:text-xl">{p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
